import React from "react";
import { HomeTitle } from "../components";
import { AiOutlineArrowDown } from "react-icons/ai";
import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import TrackVisibility from "react-on-screen";

const ServiceCard = ({ isVisible, index, service, bgColor, largebgColor }) => {
	const animation = isVisible
		? `animate-animated animate-fadeInUp delay-${index} opacity-100`
		: "opacity-0";

	return (
		<div
			className={`border md:border-0 h-full group flex flex-col md:flex-row items-start md:items-center ${largebgColor} p-2 md:p-4 rounded-xl hover:opacity-100 ${animation}`}
		>
			<img
				src={service.icon}
				alt={service.title}
				className="w-12 md:w-14 lg:w-16"
			/>
			<div
				className={`rounded-xl p-2 w-full ${bgColor} md:bg-none h-full flex flex-col justify-between mt-2 md:mt-0`}
			>
				<h3 className={`font-bold text-primary text-md md:text-2xl uppercase`}>
					{service.title}
				</h3>
				<p className={`opacity-80 text-sm md:text-md`}>{service.description}</p>
			</div>
		</div>
	);
};

const ServiceDetails = ({
	isVisible,
	title,
	image,
	description,
	bgIsGray,
	reverse,
}) => {
	const animation = isVisible
		? "animate-animated animate-fadeInLeft opacity-100 animate-faster"
		: "";
	return (
		<div className={`py-10 ${bgIsGray ? "bg-gray-50" : ""}`}>
			<div className={"opacity-0 " + animation}>
				<HomeTitle title={title} center />
				<div
					className={`container mt-10 flex flex-col-reverse justify-center ${
						reverse ? "sm:flex-row-reverse" : "sm:flex-row"
					}`}
				>
					<p className={`flex-1 leading-8 text-lg text-center sm:text-left`}>
						{description}
					</p>
					<div className="flex-1">
						<img src={image} alt={title} className="mx-auto w-36" />
					</div>
				</div>
			</div>
		</div>
	);
};

const Services = () => {
	const [lang] = useLang();
	const langWords = useWords(lang);
	useTitle(langWords.services || "");
	return (
		<div style={{ marginTop: "120px" }}>
			<HomeTitle title={langWords.services} center />
			<div className="container grid grid-cols-1 md:grid-cols-2 place-items-center mb-10">
				<div>
					<h3 className="text-3xl font-semibold text-primary mb-6 text-center sm:text-center">
						{langWords?.servicesPageSubTitle}
					</h3>
					<p
						style={{ textIndent: "2rem" }}
						className="leading-8 text-lg opacity-70 text-center md:text-left mb-10 md:mb-0"
					>
						{langWords?.servicesPageDescription}
					</p>
				</div>
				<img
					className="w-72 mx-center"
					src="/assets/illustrations/multiservices.svg"
					alt="multiservices"
				/>
			</div>
			<div className="container grid grid-cols-2 sm:grid-cols-3 gap-4">
				{langWords?.servicesList?.map((service, index) => (
					<TrackVisibility key={`service-${index}`} once>
						<ServiceCard
							service={service}
							index={index}
							bgColor={`bg-${service.altColor}`}
							largebgColor={`md:bg-${service.altColor}`}
						/>
					</TrackVisibility>
				))}
			</div>
			<div className="flex justify-center mt-10">
				<span className="flex justify-center items-center h-10 w-10 bg-primary text-secondary rounded-full animate-animated animate-pulse animate-infinite">
					<AiOutlineArrowDown />
				</span>
			</div>
			<div className="mt-24">
				{langWords.servicesList &&
					langWords.servicesList.map((service, index) => (
						<TrackVisibility key={"animated" + index} partialVisibility once>
							<ServiceDetails
								title={service.title}
								image={service.icon}
								bgIsGray={index % 2 === 0}
								reverse={index % 2 === 0}
								description={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore sit porro esse sequi! Fugiat, delectus incidunt iste, obcaecati ut non voluptatum autem porro iusto, ea quod accusamus! Quasi, sit quos.`}
							/>
						</TrackVisibility>
					))}
			</div>
		</div>
	);
};

export default Services;
